import {
  NEW_SCHEDULE_INTERVIEW_REQUEST,
  NEW_SCHEDULE_INTERVIEW_SUCCESS,
  NEW_SCHEDULE_INTERVIEW_FAIL,
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const NewScheduleInterviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_SCHEDULE_INTERVIEW_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case NEW_SCHEDULE_INTERVIEW_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case NEW_SCHEDULE_INTERVIEW_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };
    default:
      return state;
  }
};

export default NewScheduleInterviewReducer;

